import '@/lib/typedef';
import client from '@/lib/http-client';
import { buildQuery } from '@/lib/helper';

const endpoint = '/utilities';
const endpointOpenStreetMap = 'https://nominatim.openstreetmap.org';

export default {
	/**
	 * Get Presigned Url
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getPresignedUrl(params, cb, errorCb) {
		const url = `${endpoint}/presigned_url`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	/**
	 * Update Order Status
	 * @param Object params
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	updateOrderStatus(params, cb, errorCb) {
		const url = `${endpoint}/order_status`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};

// Get Locations by Name
export const searchPlace = (params, cb, errorCb) => {
	const query = buildQuery(params);
	const url = `${endpointOpenStreetMap}/search?${query}`;
	client.get(url)
		.then((response) => {
			cb(response.data);
		})
		.catch((e) => {
			errorCb(e);
		});
};
